import {
  Button,
  Stack,
  Tab,
  Tabs,
  Typography,
  Link,
  Chip,
  Radio,
  Box,
} from "@mui/material";
import {
  CustomTabPanel,
  CustomTable,
  CustomeDialog,
  DeleteModal,
  Loader,
  PageListLayout,
} from "../../../shared";
import { useMemo } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useStores } from "../hooks";
import { createColumnHelper } from "@tanstack/react-table";
import {
  FinishedProductsList,
  FinishedProductsWithoutPLU,
  ScheduledSyncList,
  SyncHistoryList,
  Settings,
} from "../components";
import { usePOSSyncLists } from "../hooks/usePOSSyncLists";

export const POSSyncLists = () => {
  let { id } = useParams();

  const { state } = usePOSSyncLists(id);

  const { dataList, isLoading } = state;

  const navigate = useNavigate();
  const { search } = useLocation();

  const handleChange = (event, newValue) => {
    navigate(`/pos-sync${newValue}`);
  };

  const breadcrumbs = [
    <Typography
      key="2"
      color="inherit"
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      POS Sync
    </Typography>,
  ];
  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => [
      {
        header: "Date & Time",
        accessorKey: "name",
      },
    ],
    [],
  );
  const columns2 = [
    columnHelper.accessor("mac_id", {
      header: () => "MAC ID",
    }),
    columnHelper.accessor("actions", {
      header: () => "",
      align: "right",
      cell: ({ row }) => {
        return (
          <Stack
            justifyContent="end"
            sx={{ cursor: "pointer", width: "fit-content", ml: "auto" }}
          >
            <img alt="delete" src="/icons/ic_trash.svg" />
          </Stack>
        );
      },
    }),
  ];

  return (
    <>
      <PageListLayout
        breadcrumbs={breadcrumbs}
        headerText="POS Sync"
        tabs={
          <Tabs value={search} onChange={handleChange}>
            <Tab label="Finished Products (PLU)" value={""} />
            <Tab
              label="Finished Products (Without PLU)"
              value={"?without-plu"}
            />
            <Tab label="Scheduled Sync" value={"?scheduled"} />
            <Tab label="Sync History" value={"?history"} />
            <Tab label="Settings" value={"?settings"} />
          </Tabs>
        }
      >
        {false ? (
          <Loader />
        ) : (
          <>
            <CustomTabPanel value={search} index={""} border={false}>
              <FinishedProductsList />
            </CustomTabPanel>
            <CustomTabPanel
              value={search}
              index={"?without-plu"}
              border={false}
            >
              <FinishedProductsWithoutPLU />
            </CustomTabPanel>
            <CustomTabPanel value={search} index={"?scheduled"} border={false}>
              <ScheduledSyncList />
            </CustomTabPanel>
            <CustomTabPanel value={search} index={"?history"} border={false}>
              <SyncHistoryList />
            </CustomTabPanel>
            <CustomTabPanel value={search} index={"?settings"} border={false}>
              <Settings />
            </CustomTabPanel>
          </>
        )}

        {/* <DeleteModal
          open={state?.deleteMacOpen}
          handleClose={() => handleModal("delete-mac", false, null)}
          onConfirm={() => removeMac()}
        /> */}
      </PageListLayout>
    </>
  );
};
